<script lang="ts" setup></script>

<template>
  <UiButton as="a" href="/auth/sign-in">
    {{ $t('login') }}
  </UiButton>
</template>

<style scoped></style>
